import $ from "jquery";
import router from '@/router' // 引入router
import Vue from 'vue';
import store from 'store'
import utils from '@/js/until.js';

import {setToken,scrollTop} from '@/libs/util'
import until from "./until";
import vue from "vue";

const getLoading = utils.globleLoading();

// function setTop(){
//   if (document.getElementById('contentTop')) {
//     document.getElementById('contentTop').scrollTop = 0;
//   }
// }

// function getVuePro() {
//   return this;
// }

// 格式化数据集合
export const formatData = {
  // 格式化列表 list
  formatListData(data) {
    // 有的有嵌套list字段有的没有

    const listData = data.data.list || data.data || {};
    const listArr = [];
    for(let key in listData) {
      const parKey = parseInt(key);
      if (typeof parKey === 'number' && !isNaN(parKey)) listArr.push(listData[key]);
    }
    return {
      ...data.data,
      list: listArr,
      total: (data.data.list && data.data.list.total) || data.data.total || data.data.count || 0,
      status: data.status,
      msg: data.msg,
    };
  },
}


function getRequestLang(type) {
  if (type === 'zh-cn') return 'zh-cn';
  else if (type === 'en') return 'en-us';
  else return 'zh-cn';
}

// var baseUrl =  until.environment()?'':'http://test.chathot.me/app/index.php?i=6&c=entry&m=new_star&'

// var baseUrl =  process.env.NODE_ENV === 'development' ? 'http://customer.chathot.me/api' : '';
// var baseUrl =  process.env.NODE_ENV === 'development' ? '' : 'http://customer.chathot.me'; // 测试服
// var baseUrl =  process.env.NODE_ENV === 'development' ? '' : 'http://api.chathot.me'; // 正式服
var baseUrl =   process.env.NODE_ENV === 'development'?'' :until.environment()?'https://api.chathot.me':'http://customer.chathot.me';
// 测试服

export const  getRequestUrl=function(url) {
  const $store = vue.prototype.$selfGlobal.$globalStore;
  const getToken = $store.state.token || store.get('login_token') || '';
  const getUid = store.get('login_uid') || '';
  return baseUrl + url + `?lang=${ getRequestLang(vue.prototype.$selfGlobal.$globalStore.state.locale) }&login_uid=${ getUid }&token=${ getToken }`;
}

function handleBoxScrollTop() {
  const getEl = document.querySelectorAll('.scroll-box');
  const getMarkEl = document.querySelectorAll('.ivu-modal-wrap');
  getEl && getEl.forEach((elItem, elIndex) => {
    // if (elIndex === getEl.length - 1)
    elItem.scrollTop = 0;
  });
  getMarkEl && getMarkEl.forEach((elItem, elIndex) => {
    elItem.scrollTop = 0;
  })
}

function handleRequestHeader(config) {
  const $store = Vue.prototype.$selfGlobal.$globalStore;
  // 设置header
  let headers = {};
  if (config && config.headers) {
    headers = Object.assign({}, headers, config.headers);
  }
  const getToken = store.get('login_token');
  // const getUid = store.get('login_uid');
  headers.token = $store.state.token || getToken || '';
  // headers['uid'] = getUid || '';
  return headers;
}

export const ajax = function (method, url, param, config) {
  return new Promise(function (resolve, reject) {
      // const selfGlobal = getVuePro.call(Vue.prototype).$selfGlobal;
      const selfGlobal = Vue.prototype.$selfGlobal;
      const $store = Vue.prototype.$selfGlobal.$globalStore;
      if (config && config.method) {
        selfGlobal && selfGlobal.$globalRequestMeth.methodList.push(config.method);
      }
      if (param && !param.noLoading) {
        getLoading.show();
      }

      const headers = handleRequestHeader(config);

      $.ajax({
        method: method,
        url: url,
        data: param,
        headers: headers,
        dataType: "json",
        crossDomain: true,
        timeout: 60 * 1000, // 响应超时时间1min
        // traditional: true,
        xhrFields: {
          withCredentials: true,
        },
        // beforeSend: function (XMLHttpRequest) {
        //   XMLHttpRequest.setRequestHeader("test-token", 'abcd');
        //   XMLHttpRequest.setRequestHeader("test-sessid", 'abcd');
        // },
        success: function (data) {
          const $globalRequestMeth = selfGlobal && selfGlobal.$globalRequestMeth;
          switch (Number(data.data.login_status) || data.status) {
            case 400:
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              Vue.prototype.$Message.error(data.msg);
              reject({
                code: 400,
              })
              // alert(data.msg);
              break;
            case 401:
              store.remove('login_token');
              // store.remove('login_uid');
              $store.commit('SETTOKEN', '');
              router.replace({
                path: '/login'
              })
              break;
            case 402: // 无操作权限
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              Vue.prototype.$Message.error(data.msg);
              break;

            case 6001:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.postRemove'));
              break;
            case 6002:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.commentRemove'));
              break;
            case 6003:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.postUnExist'));
              break;
            case 6004:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.commentUnExist'));
              break;
            case 6005:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.postUnOpera'));
              break;
            case 6006:
              Vue.prototype.$Message.error(selfGlobal.$globalI18n.tc('js.request.commentUnOpera'));
              break;
            case(403):
              break;
            case(405):
              const $globalStore = selfGlobal && selfGlobal.$globalStore;
              const getFlag = $globalStore.getters.showPasswordFlag;
              if ($globalRequestMeth) {
                $globalRequestMeth.request = false;
              }
              if (!getFlag) $globalStore.commit('setShowPasswordFlag', true);
              break;
            case(406):
              Vue.prototype.$Modal.info({
                title: selfGlobal.$globalI18n.tc('views.public.prompt'),
                okText: selfGlobal.$globalI18n.tc('views.public.sure'),
                content: data.msg,
                onOk: () => {
                  store.remove('login_token');
                  $store.commit('SETTOKEN', '');
                  // store.remove('login_uid');
                  router.replace({
                    path: '/login'
                  })
                },
              })
              break;
            // 用户禁言的407 - 411 就会跳转到指定路径
            // 407	用户被异常上报，要求请跳转至异常上报模块 处理
            // 408	要求请跳转至举报管理举报评论模块 处理
            // 409	要求请跳转至举报管理举报帖子模块 处理
            // 410	要求请跳转至举报管理举报熔断帖子模块 处理
            // 411	要求请跳转至举报管理举报熔断评论模块 处理
            case(407):
            case(408):
            case(409):
            case(410):
            case(411):
              resolve(data);
              break;
            default:
              // 比如200一类的
              // 如果出现密码框，输入密码成功，请求成功走的default
              if ($globalRequestMeth && !$globalRequestMeth.request) {
                $globalRequestMeth.request = true;
                $globalRequestMeth.methodList.forEach(item => {
                  item.method && item.method();
                })
              }
              if (config && config.method && config.method.scrollTopFlag) {
                handleBoxScrollTop();
              }
              $globalRequestMeth.methodList = [];
              resolve(data);
            // setTop()
          };
        },
        error: function (error) {
          // const $Message = getVuePro.call(Vue.prototype).$Message;
          const $Message = Vue.prototype.$Message;
          const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
          switch (error.status) {
            case(500):
              $Message.error($globalI18n.tc('js.request.systemError'));
              // alert("服务器系统内部错误");
              break;
            case(401):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              // alert("未登录");
              break;
            case(403):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              // alert("无权限执行此操作");
              break;
            case(408):
              $Message.error($globalI18n.tc('js.request.timeOut'));
              // alert("请求超时");
              break;

            case(6001):
              $Message.error($globalI18n.tc('js.request.postRemove'));
              break;
            case(6002):
              $Message.error($globalI18n.tc('js.request.commentRemove'));
              break;
            case(6003):
              $Message.error($globalI18n.tc('js.request.postUnExist'));
              break;
            case(6004):
              $Message.error($globalI18n.tc('js.request.commentUnExist'));
              break;
            case(6005):
              $Message.error($globalI18n.tc('js.request.postUnOpera'));
              break;
            case(6006):
              $Message.error($globalI18n.tc('js.request.commentUnOpera'));
              break;

            case(0):
              if (error.statusText === 'timeout') $Message.error($globalI18n.tc('js.request.timeOut'));
              else if (error.statusText === 'error' && !param.noMsg) $Message.error($globalI18n.tc('js.request.requestServerError'));
              break;
            default:
              $Message.error(error.statusText || $globalI18n.tc('js.request.unknownMis'));
              // alert("未知错误");
              break;
          }
          reject({
            code: error.status,
            error,
          });
        },
        complete() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};

export const uploadImg = function (url, param) {
  return new Promise(function (resolve, reject) {
      if (param && !param.noLoading) {
        getLoading.show();
      }
      $.ajax({
        method: 'post',
        url: url,
        data: param,
        processData: false,
        contentType: false,
        async: true,
        dataType: "json",
        timeout: 60 * 1000, // 响应超时时间60s
        success: function (data) {
          resolve(data);
        },
        error: function (error) {
          const $Message = Vue.prototype.$Message;
          const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
          switch(error.status) {
            case(408):
              $Message.error($globalI18n.tc('js.request.timeOut'));
              break;
            case(0):
              if (error.statusText === 'timeout') $Message.error($globalI18n.tc('js.request.timeOut'));
              break;
          }
          reject(error)
        },
        complete: function() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};



// WEBPACK FOOTER //
// ./src/js/request.js